document.addEventListener('DOMContentLoaded', function() {

/* ── HERO CAROUSEL ── */
document.querySelectorAll('.hero-carousel').forEach(function(carousel) {
  var slides  = Array.from(carousel.querySelectorAll('.hero-slide'));
  var dots    = Array.from(carousel.querySelectorAll('.hero-dot'));
  var prev    = carousel.querySelector('.hero-arrow.prev');
  var next    = carousel.querySelector('.hero-arrow.next');
  var current = 0;
  var timer;

  function goTo(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach(function(s, i) { s.classList.toggle('active', i === current); });
    dots.forEach(function(d, i)   { d.classList.toggle('active', i === current); });
  }

  function autoPlay() {
    clearInterval(timer);
    timer = setInterval(function() { goTo(current + 1); }, 4000);
  }

  if (prev) prev.addEventListener('click', function() { goTo(current - 1); autoPlay(); });
  if (next) next.addEventListener('click', function() { goTo(current + 1); autoPlay(); });
  dots.forEach(function(d, i) { d.addEventListener('click', function() { goTo(i); autoPlay(); }); });

  goTo(0);
  autoPlay();
});

/* ── CATEGORY FILTER TABS ── */
document.querySelectorAll('.cats').forEach(function(cats) {
  cats.querySelectorAll('.cat').forEach(function(btn) {
    btn.addEventListener('click', function() {
      cats.querySelectorAll('.cat').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var filter = btn.textContent.trim();
      var grid = cats.closest('section, .shop-main') && cats.closest('section, .shop-main').querySelector('.prod-grid, .shop-grid');
      if (!grid) return;
      grid.querySelectorAll('.prod-card').forEach(function(card) {
        if (filter === 'All') {
          card.style.display = '';
        } else {
          var name = (card.querySelector('.prod-name') ? card.querySelector('.prod-name').textContent : '').toLowerCase();
          var cat  = (card.querySelector('.prod-cat')  ? card.querySelector('.prod-cat').textContent  : '').toLowerCase();
          card.style.display = (name.includes(filter.toLowerCase()) || cat.includes(filter.toLowerCase())) ? '' : 'none';
        }
      });
    });
  });
});

/* ── FAQ ACCORDION ── */
document.querySelectorAll('.faq-item').forEach(function(item) {
  var btn = item.querySelector('.faq-q');
  if (btn) btn.addEventListener('click', function() { item.classList.toggle('active'); });
});

/* ── BEFORE/AFTER SLIDER ── */
(function() {
  var slider    = document.getElementById('ba-slider');
  var beforeWrap = document.getElementById('ba-before-wrap');
  var divLine   = document.getElementById('ba-divider-line');
  var handle    = document.getElementById('ba-handle');
  if (!slider) return;
  var dragging  = false;

  function setPos(clientX) {
    var rect = slider.getBoundingClientRect();
    var pct  = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    if (beforeWrap) beforeWrap.style.width = pct + '%';
    if (divLine)    divLine.style.left     = pct + '%';
    if (handle)     handle.style.left      = pct + '%';
  }

  slider.addEventListener('mousedown', function(e) { dragging = true; setPos(e.clientX); e.preventDefault(); });
  window.addEventListener('mousemove', function(e) { if (dragging) setPos(e.clientX); });
  window.addEventListener('mouseup',   function()  { dragging = false; });
  slider.addEventListener('touchstart', function(e) { dragging = true; setPos(e.touches[0].clientX); }, { passive: true });
  window.addEventListener('touchmove',  function(e) { if (dragging) setPos(e.touches[0].clientX); }, { passive: true });
  window.addEventListener('touchend',   function()  { dragging = false; });
})();

/* ── PINCODE DELIVERY CHECK ── */
var pinBtn = document.querySelector('.pdp-pin-btn');
var pinInput = document.querySelector('.pdp-pin-input');
var pinMsg   = document.querySelector('.pdp-pin-msg');
if (pinBtn && pinInput && pinMsg) {
  pinBtn.addEventListener('click', function() {
    var pin = pinInput.value.trim();
    if (!/^\d{6}$/.test(pin)) {
      pinMsg.textContent = 'Please enter a valid 6-digit pincode.';
      pinMsg.style.color = '#d0021b';
      return;
    }
    pinMsg.textContent = 'Checking...';
    pinMsg.style.color = 'var(--muted)';
    setTimeout(function() {
      pinMsg.textContent = '✓ Delivery available! Estimated 3-5 business days.';
      pinMsg.style.color = 'var(--sage3)';
    }, 800);
  });
  pinInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') pinBtn.click();
  });
}

/* ── ADD TO CART ── */
function addToCart(variantId, quantity, btn) {
  if (!variantId) return;
  quantity = quantity || 1;
  if (btn) { btn.textContent = 'Adding...'; btn.classList.add('adding'); }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    if (btn) { btn.textContent = 'Added ✓'; btn.style.background = 'var(--blue)'; btn.style.borderColor = 'var(--blue)'; btn.style.color = 'white'; }
    updateCartCount();
    var cartDrawer = document.getElementById('cart-drawer');
    var cartOverlay = document.getElementById('cart-overlay');
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('open');
    }
    if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
    setTimeout(function() {
      if (btn) { btn.textContent = 'Add to Cart'; btn.style.background = ''; btn.style.borderColor = ''; btn.style.color = ''; btn.classList.remove('adding'); }
    }, 2000);
  })
  .catch(function() {
    if (btn) { btn.textContent = 'Add to Cart'; btn.classList.remove('adding'); }
  });
}

/* ── CART COUNT ── */
function updateCartCount() {
  fetch('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var counters = document.querySelectorAll('.nav-cart-count');
    counters.forEach(function(el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  });
}

/* ── PDP QTY STEPPER ── */
var qtyValEl  = document.getElementById('pdp-qty-val');
var qtyMinus  = document.getElementById('pdp-qty-minus');
var qtyPlus   = document.getElementById('pdp-qty-plus');
function getPdpQty() { return qtyValEl ? Math.max(1, parseInt(qtyValEl.textContent) || 1) : 1; }
if (qtyMinus) {
  qtyMinus.addEventListener('click', function() {
    if (!qtyValEl) return;
    var cur = getPdpQty();
    if (cur > 1) qtyValEl.textContent = cur - 1;
  });
}
if (qtyPlus) {
  qtyPlus.addEventListener('click', function() {
    if (!qtyValEl) return;
    qtyValEl.textContent = getPdpQty() + 1;
  });
}

var buyNowBtn = document.getElementById('pdp-buy-now-btn');
if (buyNowBtn) {
  buyNowBtn.addEventListener('click', function() {
    var variantId = buyNowBtn.dataset.variantId;
    if (!variantId) return;
    buyNowBtn.textContent = 'Processing...';
    buyNowBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: getPdpQty() }] })
    })
    .then(function() { window.location = '/checkout'; })
    .catch(function() {
      buyNowBtn.textContent = 'Buy Now';
      buyNowBtn.disabled = false;
    });
  });
}

var pdpAddBtn = document.getElementById('pdp-add-btn');
if (pdpAddBtn) {
  pdpAddBtn.addEventListener('click', function() {
    addToCart(pdpAddBtn.dataset.variantId, getPdpQty(), pdpAddBtn);
  });
}

/* ── BUNDLE ADD ALL ── */
var bundleAddAll = document.getElementById('bundle-add-all');
if (bundleAddAll) {
  bundleAddAll.addEventListener('click', function() {
    var items = [];
    document.querySelectorAll('.bundle-card').forEach(function(card) {
      if (card.querySelector('.bundle-check').checked) {
        var vid = card.dataset.variantId;
        if (vid) items.push({ id: Number(vid), quantity: 1 });
      }
    });
    if (!items.length) return;
    bundleAddAll.textContent = 'Adding...';
    bundleAddAll.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function() {
      bundleAddAll.textContent = 'Added ✓';
      bundleAddAll.style.background = 'var(--sage3)';
      updateCartCount();
      setTimeout(function() {
        bundleAddAll.textContent = 'Add All to Cart';
        bundleAddAll.style.background = '';
        bundleAddAll.disabled = false;
      }, 2000);
    })
    .catch(function() {
      bundleAddAll.textContent = 'Add All to Cart';
      bundleAddAll.disabled = false;
    });
  });
}

document.querySelectorAll('.prod-btn').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    var variantId = btn.dataset.variantId || (btn.closest('.prod-card') && btn.closest('.prod-card').dataset.variantId);
    addToCart(variantId, 1, btn);
  });
});

/* ── PRODUCT CARD HOVER IMAGE CYCLE ── */
document.querySelectorAll('.prod-img[data-images]').forEach(function(wrap) {
  var images;
  try { images = JSON.parse(wrap.getAttribute('data-images')); } catch (e) { images = []; }
  if (images.length < 2) return;
  var img = wrap.querySelector('.prod-img-el');
  if (!img) return;
  var originalSrc = img.src;
  images.forEach(function(src) { var pre = new Image(); pre.src = src; });

  var overlay = img.cloneNode(true);
  overlay.removeAttribute('id');
  overlay.style.position = 'absolute';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.opacity = '0';
  overlay.style.transition = 'opacity .3s ease';
  overlay.style.pointerEvents = 'none';
  wrap.appendChild(overlay);

  var idx = 0, cycleTimer = null, resetTimer = null;
  function showNext() {
    idx = (idx + 1) % images.length;
    overlay.src = images[idx];
    overlay.style.opacity = '1';
    resetTimer = setTimeout(function() {
      img.src = images[idx];
      overlay.style.opacity = '0';
    }, 300);
  }
  wrap.addEventListener('mouseenter', function() {
    idx = 0;
    function cycle() {
      showNext();
      cycleTimer = setTimeout(cycle, 1100);
    }
    cycle();
  });
  wrap.addEventListener('mouseleave', function() {
    clearTimeout(cycleTimer);
    clearTimeout(resetTimer);
    overlay.style.opacity = '0';
    img.src = originalSrc;
  });
});

/* ── PREDICTIVE SEARCH (navbar + mobile) ── */
(function() {
  var CONCERN_MAP = [
    { tag: 'glow-brightening', label: 'Glow & Brightening', keywords: ['glow','brightening','bright skin','dark spot','dark spots','pigmentation','dull skin','even tone','radiance','uneven skin tone'] },
    { tag: 'oil-control', label: 'Oil Control', keywords: ['oily skin','oil control','excess oil','shine control','oiliness'] },
    { tag: 'acne-pores', label: 'Acne & Pores', keywords: ['acne','pimple','pimples','breakout','breakouts','pores','blackhead','blackheads','acne prone','acne-prone'] },
    { tag: 'hydration', label: 'Hydration', keywords: ['dry skin','hydration','moisture','dryness','dehydrated','dehydration'] },
    { tag: 'anti-aging', label: 'Anti-Aging', keywords: ['anti aging','anti-aging','anti ageing','anti-ageing','wrinkle','wrinkles','fine line','fine lines','aging skin','ageing skin'] },
    { tag: 'hair-fall', label: 'Hair Fall', keywords: ['hair fall','hairfall','hair loss','thinning hair','hair thinning'] },
    { tag: 'dandruff', label: 'Dandruff', keywords: ['dandruff','flaky scalp','dry scalp','scalp flakes'] },
    { tag: 'frizz-shine', label: 'Frizz & Shine', keywords: ['frizz','frizzy hair','frizzy','dull hair','hair shine'] },
    { tag: 'hair-growth', label: 'Hair Growth', keywords: ['hair growth','hair regrowth','thicker hair','hair thickness'] }
  ];
  function matchConcern(q) {
    var lower = q.toLowerCase();
    for (var i = 0; i < CONCERN_MAP.length; i++) {
      var c = CONCERN_MAP[i];
      for (var j = 0; j < c.keywords.length; j++) {
        if (lower.indexOf(c.keywords[j]) > -1) return c;
      }
    }
    return null;
  }
  window.ujjwalaMatchConcern = matchConcern;

  function rupees(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return '';
    try { return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 0 }); }
    catch (e) { return '₹' + Math.round(n); }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function(c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
  }); }
  function resultsUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
  }

  function attach(input) {
    if (!input) return;
    var wrap = input.closest('.nav-search-wrap');
    var dd = wrap ? wrap.querySelector('.search-dropdown') : null;
    if (!dd) return;
    var timer = null;

    function hide() { dd.hidden = true; dd.innerHTML = ''; }
    function go(q) {
      if (!q) return;
      var concern = matchConcern(q);
      if (concern) { window.location.href = '/collections/all/' + concern.tag; return; }
      window.location.href = resultsUrl(q);
    }

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { go(input.value.trim()); }
      else if (e.key === 'Escape') { hide(); }
    });

    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function() {
        var concern = matchConcern(q);
        var concernBanner = concern
          ? '<a class="sr-all" href="/collections/all/' + concern.tag + '" style="font-weight:700">Shop ' + esc(concern.label) + ' products &rarr;</a>'
          : '';
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6' +
          '&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (input.value.trim() !== q) return; // stale response
            var list = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!list.length) {
              dd.innerHTML = concernBanner || ('<div class="sr-empty">No products found for “' + esc(q) + '”</div>');
              dd.hidden = false;
              return;
            }
            var html = concernBanner + list.map(function(p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || '';
              var price = rupees(p.price);
              return '<a class="sr-item" href="' + p.url + '">' +
                (img ? '<img class="sr-thumb" src="' + img + '" alt="" loading="lazy">' : '<span class="sr-thumb"></span>') +
                '<span class="sr-info"><span class="sr-name">' + esc(p.title) + '</span>' +
                (price ? '<span class="sr-price">' + price + '</span>' : '') +
                '</span></a>';
            }).join('');
            html += '<a class="sr-all" href="' + resultsUrl(q) + '">View all results</a>';
            dd.innerHTML = html;
            dd.hidden = false;
          })
          .catch(function() { hide(); });
      }, 200);
    });

    input.addEventListener('focus', function() {
      if (dd.innerHTML && input.value.trim().length >= 2) dd.hidden = false;
    });
    document.addEventListener('click', function(e) {
      if (wrap && !wrap.contains(e.target)) hide();
    });
  }

  document.querySelectorAll('.nav-search').forEach(attach);
  attach(document.getElementById('mobile-search-input'));
})();

/* ── HAMBURGER MENU ── */
(function() {
  var hamburger = document.getElementById('nav-hamburger');
  var dropdown  = document.getElementById('mobile-nav-dropdown');
  if (!hamburger || !dropdown) return;
  function openMenu() {
    dropdown.classList.add('open');
    hamburger.innerHTML = '&#10005;';
    document.addEventListener('click', outsideClick);
  }
  function closeMenu() {
    dropdown.classList.remove('open');
    hamburger.innerHTML = '&#9776;';
    document.removeEventListener('click', outsideClick);
  }
  function outsideClick(e) {
    if (!e.target.closest('.site-header')) closeMenu();
  }
  hamburger.addEventListener('click', function(e) {
    e.stopPropagation();
    dropdown.classList.contains('open') ? closeMenu() : openMenu();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });
})();

/* ── MOBILE SEARCH TOGGLE ── */
(function() {
  var toggle = document.getElementById('nav-search-toggle');
  var panel  = document.getElementById('mobile-search-panel');
  var input  = document.getElementById('mobile-search-input');
  if (!toggle || !panel) return;
  toggle.addEventListener('click', function(e) {
    e.stopPropagation();
    var open = !panel.hidden;
    panel.hidden = open;
    toggle.setAttribute('aria-expanded', String(!open));
    if (!open && input) { input.focus(); }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !panel.hidden) { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
  });
})();

/* ── MOBILE FILTERS ── */
(function() {
  var filtersBtn = document.querySelector('.mobile-filters-btn');
  var sidebar    = document.querySelector('.shop-sidebar');
  if (!filtersBtn || !sidebar) return;
  var overlay = document.querySelector('.shop-sidebar-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'shop-sidebar-overlay';
    document.body.appendChild(overlay);
  }
  var closeBtn = document.createElement('button');
  closeBtn.textContent = '✕ Close Filters';
  closeBtn.style.cssText = 'display:block;width:calc(100% - 32px);margin:16px;padding:10px;background:var(--blue);color:white;border:none;border-radius:24px;font-family:var(--font-secondary);font-size:13px;font-weight:600;cursor:pointer';
  sidebar.insertBefore(closeBtn, sidebar.firstChild);
  function openFilters() { sidebar.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeFilters() { sidebar.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow = ''; }
  filtersBtn.addEventListener('click', openFilters);
  closeBtn.addEventListener('click', closeFilters);
  overlay.addEventListener('click', closeFilters);
})();

updateCartCount();

}); // end DOMContentLoaded